import { createAction, createReducer } from '@reduxjs/toolkit'

const initialState = JSON.parse(window.localStorage.getItem('recentProducts')) || []

export const add = createAction('recentProducts/add')

export default createReducer(initialState, builder => {
  builder.addCase(add, (state, action) => {
    if (state.indexOf(action.payload) === -1) {
      state.push(action.payload)
    }

    if (state.length > 4) {
      state.splice(0, state.length - 4)
    }

    window.localStorage.setItem('recentProducts', JSON.stringify(state))
  })
})
